import { Route, Redirect } from "react-router-dom";
import userContext from "../contexts/userContext";
import React, { useContext } from "react";
import Historique from "../example-pages/Historique";

const PrivateRoutesHistorique = () => {
  const { role, setRole } = useContext(userContext);

  return role.user ? (
    <Route path="/History/:id" component={Historique} />
  ) : (
    <Redirect to="/PagesError404" />
  );
};

export default PrivateRoutesHistorique;
